import script from "./UserCreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserCreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./UserCreateForm.vue?vue&type=style&index=0&id=34ccc460&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ccc460"]])

export default __exports__